import { HeroSection } from "@/components/HeroSection";
import { MissionSection } from "@/components/MissionSection";
import { LearningPathsSection } from "@/components/LearningPathsSection";
import { KodaSuiteSection } from "@/components/KodaSuiteSection";
import { ClassesCarouselSection } from "@/components/ClassesCarouselSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { CallToActionSection } from "@/components/CallToActionSection";
import { FaqSection } from "@/components/FaqSection";
import { SponsorSection } from "@/components/SponsorSection";
import { PartnersSection } from "@/components/PartnersSection";
import { AboutTeamSection } from "@/components/AboutTeamSection";
import { Footer } from "@/components/Footer";
import { Navbar } from "@/components/Navbar";

const Index = () => {
  const isClassicCohort: boolean = false;
  const useInterestForm: boolean = true; // Change to true to use the interest form instead of the registration form for the action button
  const showTeacher: boolean = false; // Change based on whether teachers are needed for class or not
  const showEnrollNow: boolean = isClassicCohort; // Change based on whether the active session is a regular basics class or special class
  const showBanner: boolean = false; // Change based on whether there is a class to be announced
  const bannerText: string = "Students, it's time to sign up to learn Python! Our next summer cohort is from August 3rd to 7th, 10am-11:30am EDT.";
  const showDonate: boolean = true; // Change to true to replace "Join Now" with "Donate Now" in the navbar
  const studentLink: string = !useInterestForm ? "https://forms.gle/gbNccjhz7GJPpX1d8" /* this one's the registration form */ : "https://forms.gle/jiZE1UWGBboDA2Q6A" /* this one's the interest form */;
  const educatorLink: string = "https://forms.gle/ciJvqXtf51EDDev17";

  const studentsTrusted: number = 330;

  return (
    <main className="min-h-screen bg-site">
      <Navbar studentLink={studentLink} showBanner={showBanner} bannerText={bannerText} showDonate={showDonate} />
      <div id="hero">
        <HeroSection studentLink={studentLink} educatorLink={educatorLink} showTeacher={showTeacher} showBanner={showBanner} studentNumber={studentsTrusted}/>
      </div>
      <div id="mission">
        <MissionSection />
      </div>
      <div id="classes">
        <ClassesCarouselSection studentNumber={200} classesNumber={6} schoolPartners={2} />
      </div>
      <div id="sponsors">
        <SponsorSection />
      </div>
      <div id="partners">
        <PartnersSection />
      </div>
      <div id="programs">
        <LearningPathsSection studentLink={studentLink} showEnrollNow={showEnrollNow} />
      </div>
      <div id="koda">
        <KodaSuiteSection studentNumber={studentsTrusted} schoolPartners={2} classesNumber={6} />
      </div>
      <div id="team">
        <AboutTeamSection />
      </div>
      <div id="reviews">
        <TestimonialsSection />
      </div>
      <FaqSection />
      <CallToActionSection studentLink={studentLink} educatorLink={educatorLink} showTeacher={showTeacher} />
      <div id="contact">
        <Footer />
      </div>
    </main>
  );
};

export default Index;
